export default __webpack_public_path__ + "static/media/YAS0520.34I-27816_-16712_0.936db632.jpg";